import styled from 'styled-components';

export const CourseBannerStyles = styled.div`
  
  .animationWrapper {
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      background: #FFC228;
      width: 100%;
      height: 50%;
      transition: 0.6s ease-in all;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      background: #FFC228;
      width: 100%;
      height: 50%;
      transition: 0.6s ease-in all;
    }
    
    .level {
      opacity: 0;
      transition: 0.6s 0.6s ease-in all;
      transform: translateY(25%);
    }
    
    &.active {
      &::before {
        height: 0;
      }

      &::after {
        height: 0;
      }

      .level {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }
  
  img {
    width: 100%;
    height: 600px;
    object-fit: cover;
    
    @media (max-width: 1000px) {
      height: 400px;
    }

    @media (max-width: 800px) {
      height: 300px;
    }

    @media (max-width: 500px) {
      height: 237px;
    }
  }
  
  .container {
    position: relative;
    
    .level {
      position: absolute;
      left: 16px;
      bottom: -23px;

      display: grid;
      place-items: center;
      padding: 12px 24px;
      gap: 4px;

      border: 2px solid #FFC228;
      border-radius: 2px;
      background: #1B1F2C;
      color: #FFC228;

      @media (max-width: 800px) {
        bottom: -21px;
      }

      span {
        font-weight: 700;
        font-size: 18px;
        line-height: 26px;
        
        @media (max-width: 800px) {
          font-size: 14px;
          line-height: 22px;
        }
      }
    }
  }
`;
